var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-dropdown-wrapper dropdown" },
    [
      _c(
        _setup.CButton,
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: _setup.tooltipOptions,
              expression: "tooltipOptions",
            },
          ],
          staticClass: "dropdown-toggle",
          attrs: {
            content: _vm.tooltip,
            variant: _vm.variant,
            type: "button",
            "data-toggle": "dropdown",
            "aria-expanded": "false",
          },
          on: { click: _setup.onDropdownExpanded },
        },
        [
          _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
          _c("font-awesome-icon", {
            staticClass: "ml-1",
            attrs: { icon: ["fas", _setup.props.icon ?? _setup.icon] },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu" },
        _vm._l(_vm.items, function (item, idx) {
          return _c(
            "div",
            {
              key: `dropdown-item-${idx}`,
              class: [
                item.divider ? "dropdown-item c-divider" : "dropdown-item",
                item.class,
              ],
              on: {
                click: function ($event) {
                  return _setup.handleItemClick(item)
                },
              },
            },
            [
              _vm._t(
                "dropdown-menu-item",
                function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "dropdown-menu-item-button d-flex",
                        attrs: { disabled: item.disabled },
                      },
                      [
                        _c("span", { staticClass: "item-label" }, [
                          _vm._v(_vm._s(item.label)),
                        ]),
                        _vm._v(" "),
                        item.description
                          ? _c("span", { staticClass: "item-description" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.description) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
                null,
                item
              ),
            ],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }